import { RuntimeEnvManager } from '@cfx/iconfig-env-runtime';
import type { App } from 'vue';

const envManager = new RuntimeEnvManager();

/**
   * 注册全局的Env
   * @param app
   * @returns app
   */
export function registerEnv(app: App): App {
  app.config.globalProperties.$env = envManager.env;
  return app;
}

/**
 * 在setup中获取env
 * @returns env
 */
export function getEnv(): Record<string, string> {
  return envManager.env;
}
